import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { FaEye, FaSearch, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import api from "../api/api";
import { useTranslation } from "react-i18next";
import "./AdminManagement.css";
import "./Reclamations.css";

export default function GestionReclamations() {
  const [reclamations, setReclamations] = useState([]);
  const [filteredReclamations, setFilteredReclamations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRec, setSelectedRec] = useState(null);
  const [note, setNote] = useState("");
  const { t } = useTranslation();
  const [notes, setNotes] = useState([]);
  const [search, setSearch] = useState("");
  const fetchReclamations = async () => {
      try {
        const res = await api.get("/reclamations");

        const formattedData = (res.data || []).map((rec) => ({
          ...rec,
          date: rec.date || null // on garde brut, formatage seulement à l'affichage
        }));

        setReclamations(formattedData);
        setFilteredReclamations(formattedData);
      } catch (err) {
        console.error("Erreur récupération réclamations:", err);
      }
    };
  useEffect(() => {
    fetchReclamations();
  }, []);

  useEffect(() => {
    const filtered = reclamations.filter(
      (rec) =>
        (rec.user_name || "")
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        (rec.num_tel || "").includes(search)
    );
    setFilteredReclamations(filtered);
  }, [search, reclamations]);

  const openModal = async (rec) => {
    setSelectedRec(rec);
    setNote("");
    setShowModal(true);
    try {
      const res = await api.get(`/reclamations/${rec?.id}/notes`);
      setNotes(res.data || []);
    } catch (err) {
      console.error("Erreur récupération notes :", err);
    }
  };

  const handleSubmit = async () => {
    if (!selectedRec || !note.trim()) return;

    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");

      await api.post(`/reclamations/${selectedRec?.id}/notes`, {
        note: note,
        user_id: user?.id
      });

      const resTraite = await api.patch(
        `/reclamations/${selectedRec?.id}/traite`
      );

      const notesRes = await api.get(
        `/reclamations/${selectedRec?.id}/notes`
      );
      setNotes(notesRes.data || []);

      setReclamations((prev) =>
        prev.map((rec) =>
          rec.id === selectedRec?.id
            ? { ...rec, traite: resTraite.data.traite }
            : rec
        )
      );

      setSelectedRec((prev) => ({
        ...prev,
        traite: resTraite.data.traite
      }));

      setNote("");
    } catch (error) {
      console.error("Erreur ajout note et mise à jour traite :", error);
    }
  };

  const columns = [
    { field: "user_name", headerName: t("Créé_par"), flex: 1 },
    { field: "num_tel", headerName: t("Téléphone"), flex: 1 },
    {
       field: "date",
  headerName: t("Date"),
  flex: 1,
  renderCell: (params) => {
    const date = params.row.date;
    if (!date) return "";
    const d = new Date(date);
    return isNaN(d.getTime()) ? "" : d.toLocaleDateString("fr-FR");
  }
    },
    {
      field: "action",
      headerName: t("actions"),
      flex: 1,
      renderCell: (params) => (
        <FaEye
          style={{ color: "var(--sf-night-brand, #26a6b7)", cursor: "pointer" }}
          onClick={() => openModal(params.row)}
        />
      )
    },
    {
      field: "traite",
      headerName: t("État"),
      flex: 1,
      renderCell: (params) =>
        params.value ? (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              color: "var(--sf-night-brand, #1d8290)",
              background: "var(--sf-night-surface-alt, #e8f7f9)",
              padding: "4px 8px",
              borderRadius: "5px"
            }}
          >
            <FaCheckCircle aria-hidden="true" /> {t("Traité")}
          </span>
        ) : (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              color: "var(--sf-night-danger, #f44336)",
              background: "var(--sf-night-danger-soft, #fddede)",
              padding: "4px 8px",
              borderRadius: "5px"
            }}
          >
            <FaTimesCircle aria-hidden="true" /> {t('Non traité')}
          </span>
        )
    }
  ];
    const closeModal = () => {
    setShowModal(false);
    setSelectedRec(null);
  };

  return (
    <div className="admin-management-page reclamations-page" style={{ padding: "20px" }}>
      <h2
        className="admin-management-heading"
      >
        {t('Gestion des réclamations')}
        
      </h2>

      {/* Recherche */}
      <div
        className="reclamations-toolbar"
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "flex-start"
        }}
      >
        <TextField
          variant="outlined"
          size="small"
          placeholder={t('Rechercher...')}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <FaSearch />
              </InputAdornment>
            )
          }}
          className="reclamations-search"
        />
      </div>

      {/* DataGrid */}
      <div className="admin-data-card reclamations-grid-card" style={{ height: 500, width: "100%" }}>
        <DataGrid
          rows={filteredReclamations}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 10 },
            },
          }}
          pageSizeOptions={[5, 10]}
          getRowId={(row) => row.id}
          autoHeight
        />
      </div>

      {/* Modal */}
      {showModal && selectedRec && (
        <div
          onClick={closeModal} // fermer si clic dehors
          className="reclamation-modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: "20px"
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()} // empêcher fermeture quand on clique dans le contenu
            className="reclamation-modal"
            style={{
              background: "var(--sf-night-surface, #fff)",
              padding: "20px",
              borderRadius: "10px",
              width: "400px",
              maxWidth: "90%",
              maxHeight: "80vh",
              overflowY: "auto",
              position: "relative"
            }}
          >
            {/* Bouton X en haut */}
          <div
  className="reclamation-modal-header"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "15px",
  }}
>
    <IconButton
    onClick={closeModal}
    size="small"
    style={{ padding: "2px" }} // bouton plus petit
  >
    <CloseIcon fontSize="small" />
  </IconButton>
  <h2 style={{ color: "var(--sf-night-brand, #1d8290)", margin: 0, fontSize: "1.6rem" }}>
    {t('Détails de la réclamation')}
  </h2>
</div>
            <p>
              <strong>{t('Créé_par')} :</strong>{" "}
              {selectedRec?.user_name || "Inconnu"}
            </p>
            <p>
              <strong>{t('Téléphone')} :</strong>{" "}
              {selectedRec?.num_tel || ""}
            </p>
            <p>
              <strong>{t('Date')} :</strong>{" "}
              {selectedRec?.date
                ? new Date(selectedRec.date).toLocaleDateString(
                    "fr-FR"
                  )
                : ""}
            </p>
            <p>
              <strong>{t('Message')} :</strong>
            </p>
            <div
              className="reclamation-message"
              style={{
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
                background: "var(--sf-night-surface, #f7f7f7)",
                padding: "10px",
                borderRadius: "5px",
                maxHeight: "200px",
                overflowY: "auto"
              }}
            >
              {selectedRec?.contenu || ""}
            </div>

            {/* Notes */}
            <div className="reclamation-notes" style={{ marginTop: "20px" }}>
              <h3 style={{ color: "var(--sf-night-brand, #1d8290)" }}>{t('Notes')} :</h3>
              {notes.length === 0 ? (
                <p style={{ fontStyle: "italic" }}>
                  {t("no_note_for_this_claim")}
                </p>
              ) : (
                <div
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto"
                  }}
                >
                  {notes.map((n) => (
                    <div
                      className="reclamation-note"
                      key={n.id}
                      style={{
                        border: "1px solid var(--sf-night-border, #ccc)",
                        borderRadius: "5px",
                        padding: "10px",
                        marginBottom: "10px",
                        background: "var(--sf-night-surface, #f7f7f7)"
                      }}
                    >
                      <p style={{ margin: "0" }}>
                        <strong>{n.user_name}</strong> le{" "}
                        {n.date
                          ? new Date(
                              n.date
                            ).toLocaleDateString("fr-FR")
                          : ""}
                      </p>
                      <p style={{ margin: "5px 0 0" }}>{n.note}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Ajout note */}
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder={t("Ajouter une note")}
              className="reclamation-note-input"
              style={{
                width: "100%",
                height: "80px",
                marginTop: "10px",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid var(--sf-night-border, #ccc)",
                resize: "none"
              }}
            />

            <div
              className="reclamation-form-actions"
              style={{
                marginTop: "20px",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <button
                onClick={closeModal}
                className="reclamation-cancel-button"
                style={{
                  padding: "8px 15px",
                  background: "var(--sf-night-danger-fill, #f44336)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px"
                }}
              >
                {t('cancel')}
              </button>
              <button
                onClick={handleSubmit}
                className="reclamation-save-button"
                style={{
                  padding: "8px 15px",
                  background: "var(--sf-night-primary, #26a6b7)",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px"
                }}
              >
                {t('save')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
